export const C = {
  blue:       '#00AEEF',
  blueDark:   '#0088CC',
  blueLight:  '#E8F7FD',
  grayLight:  '#F5F7FA',
  grayMid:    '#E8EAED',
  grayBorder: '#DDE1E7',
  text:       '#1A1A2E',
  textMid:    '#4A5568',
  textLight:  '#8A94A6',
  white:      '#FFFFFF',
} as const
